// extracted by mini-css-extract-plugin
export var articleFooter = "blog-post-module--articleFooter--c079f";
export var articleHeader = "blog-post-module--articleHeader--dfbd5";
export var articleLinkNext = "blog-post-module--articleLinkNext--75f5f";
export var articleLinksList = "blog-post-module--articleLinksList--f40e7";
export var articleSection = "blog-post-module--articleSection--5fe6c";
export var articleTitle = "blog-post-module--articleTitle--f6ef9";
export var comments = "blog-post-module--comments--5e2a2";
export var divider = "blog-post-module--divider--b66f9";
export var originalIndicator = "blog-post-module--originalIndicator--0e31f";
export var shareIcon = "blog-post-module--shareIcon--a967e";
export var shareList = "blog-post-module--shareList--fe1ba";
export var tags = "blog-post-module--tags--e297a";